import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ProductPage } from "./pages/ProductPage";
import { HomePage } from "./pages/HomePage";
import { AboutPage } from "./pages/AboutPage";
import { NailCommissionPage } from "./pages/NailCommissionPage";
import { ArtCommissionPage } from "./pages/ArtCommissionPage";
import { CommissionsPage } from "./pages/CommissionsPage";
import { AdminPage } from "./pages/AdminPage";
import { CartPage } from "./pages/CartPage";
import { CheckoutPage } from "./pages/CheckoutPage";
import { ProductDetailPage } from "./pages/ProductDetailPage";
import { NailMailPage } from "./pages/NailMailPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { CartProvider } from "./context/CartContext";

export const Navigation = () => {
    return (
        <CartProvider>
            <Router>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/shop" element={<ProductPage />} />
                    <Route path="/shop/:productId" element={<ProductDetailPage />} />
                    <Route path="/shop/:category/:productSlug" element={<ProductDetailPage />} />
                    <Route path="/commissions" element={<CommissionsPage />} />
                    <Route path="/commissions/nails" element={<NailCommissionPage />} />
                    <Route path="/commissions/art" element={<ArtCommissionPage />} />
                    <Route path="/shop/custom-commission" element={<NailCommissionPage />} />
                    <Route path="/shop/art-commission" element={<ArtCommissionPage />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/cart" element={<CartPage />} />
                    <Route path="/checkout" element={<CheckoutPage />} />
                    <Route path="/nail-mail" element={<NailMailPage />} />
                    <Route path="/admin" element={<AdminPage />} />

                    {/* Legacy redirects for old PascalCase routes */}
                    <Route path="/NailCommission" element={<Navigate to="/commissions/nails" replace />} />
                    <Route path="/About" element={<Navigate to="/about" replace />} />
                    <Route path="/Checkout" element={<Navigate to="/checkout" replace />} />

                    {/* 404 */}
                    <Route path="*" element={<NotFoundPage />} />
                </Routes>
            </Router>
        </CartProvider>
    );
};
